// extracted by mini-css-extract-plugin
module.exports = {"tabs":"NavigationTabs_tabs__3Nxjr","tab":"NavigationTabs_tab__32PYU","tab__active":"NavigationTabs_tab__active__D20Lq"};